/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ManagerDispositionMainViewQueryRendererViewerQueryVariables = {
    startdate?: string | null | undefined;
    enddate?: string | null | undefined;
    lang: string;
    prefixes?: Array<string | null> | null | undefined;
    rightsFilter?: Array<string | null> | null | undefined;
};
export type ManagerDispositionMainViewQueryRendererViewerQueryResponse = {
    readonly viewer: {
        readonly userId: string;
        readonly rights: ReadonlyArray<{
            readonly right: string | null;
        } | null> | null;
    } | null;
    readonly holidayList: {
        readonly holidays: ReadonlyArray<{
            readonly date: string | null;
            readonly occasion: string | null;
        } | null> | null;
    } | null;
    readonly translationList: {
        readonly translations: ReadonlyArray<{
            readonly component: string | null;
            readonly text: string | null;
        } | null> | null;
    } | null;
    readonly stationList: {
        readonly stations: ReadonlyArray<{
            readonly stationId: string | null;
            readonly city: string | null;
            readonly country: {
                readonly countryId: string;
                readonly name: string | null;
                readonly sign: string | null;
            } | null;
            readonly disponame: string | null;
            readonly email: string | null;
            readonly fax: string | null;
            readonly isForeignStation: boolean | null;
            readonly isOneWayStation: boolean | null;
            readonly isRentStation: boolean | null;
            readonly isSharingStation: boolean | null;
            readonly latitude: number | null;
            readonly longitude: number | null;
            readonly name: string | null;
            readonly openingdate: string | null;
            readonly opentime: ReadonlyArray<{
                readonly breakEndtime: string | null;
                readonly breakStarttime: string | null;
                readonly endtime: string | null;
                readonly opentimeId: string;
                readonly starttime: string | null;
                readonly station: string | null;
                readonly weekDay: string | null;
            } | null> | null;
            readonly phonenumber: string | null;
            readonly street: string | null;
            readonly zipcode: string | null;
            readonly autoGenerateVehicleId: boolean | null;
        } | null> | null;
    } | null;
    readonly categoryList: {
        readonly categories: ReadonlyArray<{
            readonly categoryId: string;
            readonly sort: number | null;
            readonly enabledVehicleGroups: ReadonlyArray<{
                readonly vehicleGroupId: string;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly colorList: {
        readonly colors: ReadonlyArray<{
            readonly code: string | null;
            readonly color: string | null;
            readonly colorId: string;
            readonly description: string | null;
            readonly legendCrw: boolean | null;
            readonly legendGroup: string | null;
            readonly legendShorttext: string | null;
        } | null> | null;
    } | null;
    readonly equipmentList: {
        readonly equipments: ReadonlyArray<{
            readonly equipmentId: string;
            readonly description: string | null;
            readonly showInDispo: boolean | null;
        } | null> | null;
    } | null;
    readonly legendList: {
        readonly legends: ReadonlyArray<{
            readonly code: string | null;
            readonly color: string | null;
            readonly description: string | null;
            readonly legendCrw: boolean | null;
            readonly legendShorttext: string | null;
            readonly legendGroup: string | null;
        } | null> | null;
    } | null;
    readonly regionList: {
        readonly regions: ReadonlyArray<{
            readonly region: string | null;
            readonly enabledStations: ReadonlyArray<{
                readonly stationId: string | null;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly vehicleGroupList: {
        readonly vehicleGroups: ReadonlyArray<{
            readonly vehicleGroupId: string;
            readonly category: string | null;
            readonly categoryText: string | null;
            readonly description: string | null;
            readonly descriptionWeb: string | null;
            readonly isEnabledForInternetUsage: boolean | null;
            readonly sort: number | null;
            readonly textWeb: string | null;
        } | null> | null;
    } | null;
};
export type ManagerDispositionMainViewQueryRendererViewerQuery = {
    readonly response: ManagerDispositionMainViewQueryRendererViewerQueryResponse;
    readonly variables: ManagerDispositionMainViewQueryRendererViewerQueryVariables;
};



/*
query ManagerDispositionMainViewQueryRendererViewerQuery(
  $startdate: String
  $enddate: String
  $lang: String!
  $prefixes: [String]
  $rightsFilter: [String]
) {
  viewer {
    userId
    rights(filter: $rightsFilter) {
      right
    }
  }
  holidayList(startdate: $startdate, enddate: $enddate) {
    holidays {
      date
      occasion
    }
  }
  translationList(lang: $lang, prefixes: $prefixes) {
    translations {
      component
      text
    }
  }
  stationList {
    stations {
      stationId
      city
      country {
        countryId
        name
        sign
      }
      disponame
      email
      fax
      isForeignStation
      isOneWayStation
      isRentStation
      isSharingStation
      latitude
      longitude
      name
      openingdate
      opentime {
        breakEndtime
        breakStarttime
        endtime
        opentimeId
        starttime
        station
        weekDay
      }
      phonenumber
      street
      zipcode
      autoGenerateVehicleId
    }
  }
  categoryList {
    categories {
      categoryId
      sort
      enabledVehicleGroups {
        vehicleGroupId
      }
    }
  }
  colorList {
    colors {
      code
      color
      colorId
      description
      legendCrw
      legendGroup
      legendShorttext
    }
  }
  equipmentList {
    equipments {
      equipmentId
      description
      showInDispo
    }
  }
  legendList {
    legends {
      code
      color
      description
      legendCrw
      legendShorttext
      legendGroup
    }
  }
  regionList {
    regions {
      region
      enabledStations {
        stationId
      }
    }
  }
  vehicleGroupList {
    vehicleGroups {
      vehicleGroupId
      category
      categoryText
      description
      descriptionWeb
      isEnabledForInternetUsage
      sort
      textWeb
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enddate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "prefixes"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rightsFilter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startdate"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stationId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sort",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vehicleGroupId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legendCrw",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legendGroup",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legendShorttext",
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "rightsFilter"
          }
        ],
        "concreteType": "Right",
        "kind": "LinkedField",
        "name": "rights",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "right",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enddate",
        "variableName": "enddate"
      },
      {
        "kind": "Variable",
        "name": "startdate",
        "variableName": "startdate"
      }
    ],
    "concreteType": "HolidayList",
    "kind": "LinkedField",
    "name": "holidayList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Holiday",
        "kind": "LinkedField",
        "name": "holidays",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occasion",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lang",
        "variableName": "lang"
      },
      {
        "kind": "Variable",
        "name": "prefixes",
        "variableName": "prefixes"
      }
    ],
    "concreteType": "TranslationList",
    "kind": "LinkedField",
    "name": "translationList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Translation",
        "kind": "LinkedField",
        "name": "translations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "component",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "StationList",
    "kind": "LinkedField",
    "name": "stationList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Station",
        "kind": "LinkedField",
        "name": "stations",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryId",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sign",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disponame",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fax",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isForeignStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOneWayStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRentStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSharingStation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "latitude",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longitude",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "openingdate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Opentime",
            "kind": "LinkedField",
            "name": "opentime",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "breakEndtime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "breakStarttime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endtime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "opentimeId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "starttime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "station",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "weekDay",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phonenumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "zipcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoGenerateVehicleId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CategoryList",
    "kind": "LinkedField",
    "name": "categoryList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "categories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryId",
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VehicleGroup",
            "kind": "LinkedField",
            "name": "enabledVehicleGroups",
            "plural": true,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ColorList",
    "kind": "LinkedField",
    "name": "colorList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Color",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorId",
            "storageKey": null
          },
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "EquipmentList",
    "kind": "LinkedField",
    "name": "equipmentList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Equipment",
        "kind": "LinkedField",
        "name": "equipments",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "equipmentId",
            "storageKey": null
          },
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showInDispo",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "LegendList",
    "kind": "LinkedField",
    "name": "legendList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Legend",
        "kind": "LinkedField",
        "name": "legends",
        "plural": true,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v14/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RegionList",
    "kind": "LinkedField",
    "name": "regionList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "regions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "region",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Station",
            "kind": "LinkedField",
            "name": "enabledStations",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "VehicleGroupList",
    "kind": "LinkedField",
    "name": "vehicleGroupList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VehicleGroup",
        "kind": "LinkedField",
        "name": "vehicleGroups",
        "plural": true,
        "selections": [
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryText",
            "storageKey": null
          },
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "descriptionWeb",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEnabledForInternetUsage",
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "textWeb",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ManagerDispositionMainViewQueryRendererViewerQuery",
    "selections": (v15/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ManagerDispositionMainViewQueryRendererViewerQuery",
    "selections": (v15/*: any*/)
  },
  "params": {
    "cacheID": "65ac4b02a3a3634cacf255cdcffc5014",
    "id": null,
    "metadata": {},
    "name": "ManagerDispositionMainViewQueryRendererViewerQuery",
    "operationKind": "query",
    "text": "query ManagerDispositionMainViewQueryRendererViewerQuery(\n  $startdate: String\n  $enddate: String\n  $lang: String!\n  $prefixes: [String]\n  $rightsFilter: [String]\n) {\n  viewer {\n    userId\n    rights(filter: $rightsFilter) {\n      right\n    }\n  }\n  holidayList(startdate: $startdate, enddate: $enddate) {\n    holidays {\n      date\n      occasion\n    }\n  }\n  translationList(lang: $lang, prefixes: $prefixes) {\n    translations {\n      component\n      text\n    }\n  }\n  stationList {\n    stations {\n      stationId\n      city\n      country {\n        countryId\n        name\n        sign\n      }\n      disponame\n      email\n      fax\n      isForeignStation\n      isOneWayStation\n      isRentStation\n      isSharingStation\n      latitude\n      longitude\n      name\n      openingdate\n      opentime {\n        breakEndtime\n        breakStarttime\n        endtime\n        opentimeId\n        starttime\n        station\n        weekDay\n      }\n      phonenumber\n      street\n      zipcode\n      autoGenerateVehicleId\n    }\n  }\n  categoryList {\n    categories {\n      categoryId\n      sort\n      enabledVehicleGroups {\n        vehicleGroupId\n      }\n    }\n  }\n  colorList {\n    colors {\n      code\n      color\n      colorId\n      description\n      legendCrw\n      legendGroup\n      legendShorttext\n    }\n  }\n  equipmentList {\n    equipments {\n      equipmentId\n      description\n      showInDispo\n    }\n  }\n  legendList {\n    legends {\n      code\n      color\n      description\n      legendCrw\n      legendShorttext\n      legendGroup\n    }\n  }\n  regionList {\n    regions {\n      region\n      enabledStations {\n        stationId\n      }\n    }\n  }\n  vehicleGroupList {\n    vehicleGroups {\n      vehicleGroupId\n      category\n      categoryText\n      description\n      descriptionWeb\n      isEnabledForInternetUsage\n      sort\n      textWeb\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '20b3b9bf7d4aa99cca475fff389e50e5';
export default node;
